import { useState } from "react";
import axios from "axios";

const usePost = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (body, overrideUrl) => {
    const token = JSON.parse(sessionStorage.getItem("userData"));
    const access_token = token ? token.access_token : null;
    setError(null);
    try {
      setLoading(true);
      const response = await axios.post(overrideUrl ?? url, body, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setData(response?.data);
      return response?.data ?? null;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData };
};

export default usePost;
